import { Component, computed, inject, input } from '@angular/core';
import { PositionView, ShippingTargetDialogState } from '../shipping-target-dialog.state';

/**
 * Rahmen einer Position im Versandziel-Dialog: Nummer, Titel, Erklärtext und
 * der Status als Rahmenfarbe — grün sobald die Angabe vollständig ist, rot
 * solange etwas fehlt. Während ein Wert noch geladen wird (und bei
 * schreibgeschützten Configs) bleibt der Rahmen neutral.
 */
@Component({
  standalone: true,
  selector: 'hawk-shipping-position-card',
  template: `
    <div
      class="bm-card bm-card-sm bm-card-border transition-colors"
      [class.border-success]="tone() === 'ok'"
      [class.border-error]="tone() === 'missing'"
      [class.border-base-300]="tone() === 'neutral'"
    >
      <div class="bm-card-body">
        <div class="flex items-start gap-2">
          <span class="bm-badge bm-badge-neutral bm-badge-xs shrink-0">{{ pos().index }}</span>
          <div class="min-w-0 flex-1">
            <div class="font-semibold text-sm">{{ pos().meta.title }}</div>
            <div class="text-xs opacity-60">{{ pos().meta.hint }}</div>
          </div>
          @if (tone() === "ok") {
            <span class="text-success shrink-0" title="vollständig">✓</span>
          } @else if (tone() === "missing") {
            <span class="bm-badge bm-badge-xs shrink-0 text-error">fehlt</span>
          }
        </div>
        <div class="mt-1">
          <ng-content />
        </div>
      </div>
    </div>
  `,
})
export class ShippingPositionCardComponent {
  protected state = inject(ShippingTargetDialogState);

  readonly pos = input.required<PositionView>();

  protected tone = computed<'ok' | 'missing' | 'neutral'>(() => {
    if (this.state.readOnly() || this.pos().pending) return 'neutral';
    return this.pos().valid ? 'ok' : 'missing';
  });
}
